import { Flex } from "@chakra-ui/react";
import SelectableButton from "components/Button/SelectableButton";
import colors from "core/resources/theme/colors";
import {
  RelatorioAuditoriaQueryParams,
  TipoEventoAuditoriaEnum,
} from "core/features/relatorios/typings";

interface FilterTagProps {
  onChangeFiltro: (newValues: Partial<RelatorioAuditoriaQueryParams>) => void;
  filtro: RelatorioAuditoriaQueryParams;
}

export default function FilterTag({ filtro, onChangeFiltro }: FilterTagProps) {
  const onUnselect = () => onChangeFiltro({ tipoEvento: undefined });
  return (
    <Flex gridGap="16px">
      <SelectableButton
        selected={filtro.tipoEvento === TipoEventoAuditoriaEnum.Criacao}
        onClick={() => {
          onChangeFiltro({
            tipoEvento: TipoEventoAuditoriaEnum.Criacao,
          });
        }}
        onUnselect={onUnselect}
        rounded="full"
        selectedColor={colors.green500}
        fontSize="14px"
      >
        Criação
      </SelectableButton>
      <SelectableButton
        selected={filtro.tipoEvento === TipoEventoAuditoriaEnum.Atualizacao}
        onClick={() => {
          onChangeFiltro({
            tipoEvento: TipoEventoAuditoriaEnum.Atualizacao,
          });
        }}
        onUnselect={onUnselect}
        rounded="full"
        selectedColor={colors.blue}
        fontSize="14px"
      >
        Atualização
      </SelectableButton>
      <SelectableButton
        selected={filtro.tipoEvento === TipoEventoAuditoriaEnum.Exclusao}
        onClick={() => {
          onChangeFiltro({
            tipoEvento: TipoEventoAuditoriaEnum.Exclusao,
          });
        }}
        onUnselect={onUnselect}
        rounded="full"
        selectedColor={colors.red}
        fontSize="14px"
      >
        Exclusão
      </SelectableButton>
      <SelectableButton
        selected={filtro.tipoEvento === TipoEventoAuditoriaEnum.Cancelamento}
        onClick={() => {
          onChangeFiltro({
            tipoEvento: TipoEventoAuditoriaEnum.Cancelamento,
          });
        }}
        onUnselect={onUnselect}
        rounded="full"
        selectedColor={colors.red}
        fontSize="14px"
      >
        Cancelamento
      </SelectableButton>
    </Flex>
  );
}
